import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import moment from 'moment';
@Pipe({
  name: 'fieldparse'
})
export class FieldparsePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    if (args[0] === 'text') {
      return value;
    } else if (args[0] === 'date') {
      return moment(value || null).format('ll');
    }
    return null;
  }

}


@Pipe({
  name: 'filterfieldparse'
})
export class FilterFieldparsePipe implements PipeTransform {
  constructor(protected sanitizer: DomSanitizer) { }
  transform(value: any, args: any): unknown {
    if (args.type === 'text' || args.type === 'number' || args.type === 'email' || args.type === 'tel' || args.type === 'textarea' || args.type === 'slider') {
      return value;
    } else if (args.type === 'date') {
      return moment(value).format('ll');
    }
    else if (args.type === 'datetime') {
      return moment(value).format('lll');
    }
    else if (args.type === 'select' || args.type === 'checkbox' || args.type === 'checklist') {
      if (!args.advanced) {
        return value;
      } else {
        return value.value;
      }
    } else if (args.type === 'toggle') {
      if (!!value) { return "Yes" } else { return "No"; }
    } else if (args.type === 'user') {
      return this.sanitizer.bypassSecurityTrustHtml(this.usersListParse(value?.id, value?.photo, value?.user_name, value?.email));
    }
    return null;
  }

  usersListParse(id, url, name, email) {
    if (!url) {
      url = 'https://app.atmavaan.com/uploads/user_empty.svg';
    } else {
      url = 'https://app.atmavaan.com/uploads/user_profile/70/' + id + '_photo';
    }
    let str = `<div class="grid grid-gap-5  user-c pad-5 pointer">
    <div class='flex'>
      <img loading="lazy" class="round border-r-50 box-20 obj-f-c"  src="${url}"/>
    </div>
      <div class="flex align-c font-12">
      ${name}
      </div>
    </div>`
    return str;
  }

}



@Pipe({ name: 'safeHtml' })
export class Safe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }

  transform(style) {
    return this.sanitizer.bypassSecurityTrustHtml(style);
  }
}


@Pipe({ name: 'utcToLocalTime' })
export class UtcToLocalTime implements PipeTransform {

  transform(value) {
    var stillUtc = moment.utc(new Date(value)).toDate();
    return moment(stillUtc).local().format('lll');
  }
}

@Pipe({ name: 'formatDateTime' })
export class FormatDateTime implements PipeTransform {

  transform(value) {
    return moment(value).format('ll');
  }
}



